import { useFilterItemByField } from '@aibees/elephant/feature/search-filters//hooks/use-filter-item-by-field';
import { useFilterItemsNotOfType } from '@aibees/elephant/feature/search-filters//hooks/use-filter-items-not-of-type';
import { useFilterItemsOfType } from '@aibees/elephant/feature/search-filters//hooks/use-filter-items-of-type';
import { getFieldsByFilterItems } from '@aibees/elephant/feature/search-filters/components/filter-tags/utils';
import { buildSearchParamsDraft } from '@aibees/elephant/feature/search-filters/filters/radio-group-filter';
import { findOpenFilterItems } from '@aibees/elephant/feature/search-filters/utils';
import { useSearchQueryFilterSetters } from '@aibees/elephant/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo, useMemo, useState } from 'react';
import { SearchFilterType } from '../../types';
import { AppliedFilters } from '../applied-filters';
import { ButtonGroupFilterItem } from './components/button-group-filter-item';
import { ButtonGroupList } from './components/button-group-list';
import type { ButtonGroupFilterProps as Props } from './types';

export const ButtonGroupFilter = memo(({ className, ...filter }: Props) => {
  const { setParams } = useSearchQueryFilterSetters();
  const defaultOpen = findOpenFilterItems(filter)?.at(
    filter.metadata?.tabs?.defaultOpenIndex ?? 0
  );
  const [open, setOpen] = useState<string | undefined>(defaultOpen);

  const appliedFilterItem = useFilterItemsOfType(
    filter,
    SearchFilterType.APPLIED_FILTERS
  )?.at(0);

  const items = useFilterItemsNotOfType(
    filter,
    [SearchFilterType.APPLIED_FILTERS],
    ['company_ids']
  );

  const openFilter = useFilterItemByField(items!, open ?? '');

  const fields = useMemo(() => getFieldsByFilterItems(items!), [items]);
  const handleChange = (field: string) => {
    setOpen(field);

    if (!filter.metadata?.allowParallelItems) {
      const draft = buildSearchParamsDraft(fields, field);
      setParams(draft);
    }
  };

  return (
    <Box
      className={classnames('ButtonGroupFilter', className)}
      display={'flex'}
      flexDirection={'column'}
      gap={1}
    >
      <ButtonGroupList
        items={items ?? []}
        onChange={handleChange}
        open={open}
      />
      {appliedFilterItem && (
        <AppliedFilters openItem={open} {...appliedFilterItem} />
      )}

      {openFilter && (
        <ButtonGroupFilterItem
          open={openFilter?.open || open === openFilter.field}
          {...openFilter}
        />
      )}
    </Box>
  );
});

ButtonGroupFilter.displayName = 'ButtonGroupFilter';
